"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.smartGrid = void 0;
var React = require("react");
var axios_1 = require("axios");
var Pagination_1 = require("../components/Pagination");
var Grid_1 = require("../components/Grid");
var lodash_1 = require("lodash");
function smartGrid(_a) {
    var WrappedComponent = _a.WrappedComponent, dataFormatter = _a.dataFormatter;
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.buildFetchURL = function (exporting) {
                if (exporting === void 0) { exporting = false; }
                var sortStr = '';
                var outURL = exporting ? _this.props.exportURL || '' : _this.props.fetchURL;
                var _a = _this.state, filtered = _a.filtered, topRightFilter = _a.topRightFilter;
                if (topRightFilter) {
                    filtered = (filtered ? filtered : []).concat([topRightFilter]);
                }
                var _b = _this.state, sorted = _b.sorted, page = _b.page, pageSize = _b.pageSize, searchValue = _b.searchValue;
                var pageSizeStr = "&pageSize=" + pageSize;
                var pageNumberStr = "&pageNumber=" + (page + _this.state.pageIndexBase);
                var searchStr = searchValue ? "&search=" + searchValue : '';
                if (sorted) {
                    var sorts = [];
                    sortStr = '&sort=';
                    for (var key in sorted) {
                        sorts.push(key + " " + sorted[key]);
                    }
                    sortStr += sorts.join(',');
                }
                var includeQSStart = outURL.indexOf('?') === -1;
                outURL += "" + (includeQSStart ? '?' : '') + searchStr + sortStr + pageSizeStr + pageNumberStr;
                if (filtered && filtered.length > 0) {
                    outURL += filtered.reduce(function (previous, filter) {
                        return (previous += "&" + filter.key + "=" + filter.value);
                    }, '');
                }
                return outURL;
            };
            _this.clearSelectedItems = function () {
                _this.setSelectedItems([]);
            };
            _this.selectAllItems = function () {
                var data = _this.state.data;
                _this.setSelectedItems(__spreadArray([], data));
            };
            _this.setSelectedItems = function (items) {
                _this.setState({ selectedItems: items }, function () {
                    var onSelectedItemsChange = _this.props.onSelectedItemsChange;
                    if (typeof onSelectedItemsChange !== 'function') {
                        return;
                    }
                    onSelectedItemsChange(_this.state.selectedItems || []);
                });
            };
            _this.debounceFetch = lodash_1.debounce(function () { return _this.fetchData(); }, 300);
            _this.onSearchChanged = function (e) {
                _this.setState({
                    searchValue: e.target.value,
                    page: 0,
                }, function () {
                    _this.debounceFetch();
                    _this.clearSelectedItems();
                });
            };
            _this.onColumnClicked = function (column) {
                if (!column.sortable)
                    return;
                var _a = _this.state.sorted, sorted = _a === void 0 ? {} : _a;
                if (sorted[column.key]) {
                    if (sorted[column.key] === 'ASC') {
                        sorted[column.key] = 'DESC';
                    }
                    else {
                        delete sorted[column.key];
                    }
                }
                else {
                    sorted[column.key] = 'ASC';
                }
                _this.setState({ sorted: sorted }, _this.fetchData);
            };
            _this.addFilter = function (filter, filterValue) {
                var filtered = _this.state.filtered;
                if (Array.isArray(filtered)) {
                    var newState = __assign(__assign({}, _this.state), { filtered: __spreadArray(__spreadArray([], filtered), [
                            __assign(__assign({}, filter), { value: filterValue }),
                        ]) });
                    newState = _this.addOnFilterChangedState(newState);
                    _this.setState(newState, function () {
                        _this.fetchData();
                        _this.clearSelectedItems();
                    });
                }
            };
            _this.addOnFilterChangedState = function (newState) {
                var onFilterChanged = _this.props.onFilterChanged;
                if (typeof onFilterChanged === 'function') {
                    var filterChangeState = onFilterChanged(newState);
                    if (typeof filterChangeState !== 'undefined') {
                        newState = __assign(__assign({}, newState), filterChangeState);
                    }
                }
                return newState;
            };
            _this.removeFilter = function (filter) {
                var filtered = _this.state.filtered;
                if (filtered) {
                    _this.setState({
                        filtered: filtered.filter(function (f) { return f.key !== filter.key; }),
                    }, function () {
                        _this.fetchData();
                        _this.clearSelectedItems();
                    });
                }
            };
            _this.onTopRightFilterChanged = function (key, value) {
                if (_this.state.topRightFilter) {
                    var newState = __assign(__assign({}, _this.state), { topRightFilter: __assign(__assign({}, _this.state.topRightFilter), { value: value }) });
                    newState = _this.addOnFilterChangedState(newState);
                    _this.setState(newState, _this.fetchData);
                }
            };
            _this.onPageChanged = function (e, _a) {
                var page = _a.activePage;
                _this.setState({ page: page - 1 }, function () { return _this.fetchData(); });
            };
            _this.onPageSizeChanged = function (_a) {
                var pageSize = _a.value;
                _this.setState({ pageSize: pageSize, page: 0 }, function () { return _this.fetchData(); });
            };
            _this.onRowSelected = function (checkboxInfo, data, index) {
                var _a = _this.props, gridOptions = _a.gridOptions, onSelectedItemsChange = _a.onSelectedItemsChange;
                var _b = _this.state.selectedItems, selectedItems = _b === void 0 ? [] : _b;
                if (checkboxInfo.checked) {
                    selectedItems.push(data);
                }
                else if (gridOptions && gridOptions.selectionKey) {
                    var indexToDeselect = selectedItems.findIndex(function (item) {
                        return item[gridOptions.selectionKey || ''] ===
                            data[gridOptions.selectionKey || ''];
                    });
                    if (indexToDeselect >= 0) {
                        selectedItems.splice(indexToDeselect, 1);
                    }
                }
                _this.setState({
                    selectedItems: selectedItems,
                }, function () {
                    typeof onSelectedItemsChange === 'function' &&
                        onSelectedItemsChange(selectedItems);
                });
            };
            _this.onToggleSelectionColumn = function (checkboxInfo, data) {
                var _a = _this.props, gridOptions = _a.gridOptions, onSelectedItemsChange = _a.onSelectedItemsChange;
                var _b = _this.state.selectedItems, selectedItems = _b === void 0 ? [] : _b;
                data.map(function (row) {
                    if (gridOptions && gridOptions.selectionKey) {
                        var existingSelectedIndex = selectedItems.findIndex(function (item) {
                            return item[gridOptions.selectionKey || ''] ===
                                row[gridOptions.selectionKey || ''];
                        });
                        if (checkboxInfo.checked && existingSelectedIndex < 0) {
                            selectedItems.push(row);
                        }
                        else if (!checkboxInfo.checked && existingSelectedIndex >= 0) {
                            selectedItems.splice(existingSelectedIndex, 1);
                        }
                    }
                });
                _this.setState({
                    selectedItems: selectedItems,
                }, function () {
                    typeof onSelectedItemsChange === 'function' &&
                        onSelectedItemsChange(selectedItems);
                });
            };
            return _this;
        }
        class_1.prototype.componentWillMount = function () {
            this.setState({
                data: [],
                count: 0,
                totalOnPage: 0,
                sorted: this.props.defaultSort || {},
                filtered: this.props.defaultFilters || [],
                page: this.props.page || 0,
                pageSize: this.props.pageSize || 10,
                pageIndexBase: this.props.pageIndexBase || 0,
                totalPages: this.props.totalPages || 1,
                topRightFilter: (this.props.gridOptions && this.props.gridOptions.topRightFilter) ||
                    undefined,
                selectedItems: [],
            }, this.fetchData);
        };
        class_1.prototype.fetchData = function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setState({ isFetching: true });
                            return [4 /*yield*/, axios_1.default.get(this.buildFetchURL(), this.props.fetchOptions || undefined)];
                        case 1:
                            response = _a.sent();
                            data = response.data;
                            if (typeof dataFormatter === 'function') {
                                data = dataFormatter(data);
                            }
                            this.setState({
                                data: data.items,
                                count: data.count,
                                totalPages: data.pages,
                                pageSize: data.pageSize,
                                totalOnPage: data.items.length,
                                isFetching: false,
                            });
                            this.props.setFetchResponse && this.props.setFetchResponse(data);
                            return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _this = this;
            var _a = this.state, data = _a.data, count = _a.count, totalOnPage = _a.totalOnPage, searchValue = _a.searchValue, isFetching = _a.isFetching, filtered = _a.filtered, sorted = _a.sorted, page = _a.page, pageSize = _a.pageSize, totalPages = _a.totalPages, topRightFilter = _a.topRightFilter, selectedItems = _a.selectedItems;
            var _b = this.props, renderRow = _b.renderRow, gridOptions = _b.gridOptions, columns = _b.columns, parentRef = _b.parentRef, onSelectedItemsChange = _b.onSelectedItemsChange;
            var filters = [];
            if (gridOptions &&
                gridOptions.filters &&
                gridOptions.filters.length > 0) {
                var selected_1 = this.state.filtered
                    ? this.state.filtered.map(function (s) { return s.key; })
                    : [];
                filters = gridOptions.filters.filter(function (f) { return selected_1.indexOf(f.key) === -1; });
            }
            return (React.createElement("div", { ref: parentRef || null },
                React.createElement(Grid_1.Grid, __assign({}, gridOptions, { renderTableSubHeader: function (p) {
                        if (gridOptions &&
                            typeof gridOptions === 'object' &&
                            typeof gridOptions.renderTableSubHeader === 'function') {
                            return gridOptions.renderTableSubHeader(__assign(__assign({}, p), _this.props), {
                                clearSelectedItems: _this.clearSelectedItems,
                                selectAllItems: _this.selectAllItems,
                            });
                        }
                        return null;
                    }, searchValue: searchValue, count: count, totalOnPage: totalOnPage, data: data, columns: columns, renderRow: renderRow, isFetching: isFetching, filters: filters, sorted: sorted, onSearchChanged: this.onSearchChanged, onColumnClicked: this.onColumnClicked, 
                    // Search Change
                    selectedFilters: filtered, 
                    // Add Filters
                    onFilterApplied: this.addFilter, 
                    // Remove Filters
                    onFilterRemoveClicked: this.removeFilter, 
                    // Top Right Filter
                    onTopRightFilterChanged: this.onTopRightFilterChanged, topRightFilter: topRightFilter, 
                    // Selectable
                    onRowSelected: this.onRowSelected, selectedItems: selectedItems, onSelectedItemsChange: onSelectedItemsChange, onToggleSelectionColumn: this.onToggleSelectionColumn })),
                React.createElement(Pagination_1.default, { page: page + 1, pageSize: pageSize, onPageSizeChanged: this.onPageSizeChanged, onPageChanged: this.onPageChanged, totalPages: totalPages })));
        };
        return class_1;
    }(React.Component));
}
exports.smartGrid = smartGrid;
//# sourceMappingURL=SmartGrid.js.map